module.exports = __webpack_public_path__ + "img/diashow (10).a57b484.jpg";